import { toHumanReadable } from '@core/logic';
import { HouseLeadVariant, houseLeadVariants } from '@elements/types';
import { Chip, Stack, Typography } from '@mui/material';

export const HouseLeadVariantSelector = ({
  selectedVariant,
  toggleVariant,
}: {
  selectedVariant: HouseLeadVariant | undefined;
  toggleVariant: (variant: HouseLeadVariant) => void;
}) => {
  return (
    <>
      <Typography variant="subtitle2" color="secondary">
        House Lead Variant
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {houseLeadVariants.map((variant) => (
          <Chip
            color={selectedVariant === variant ? 'primary' : 'default'}
            variant={selectedVariant === variant ? 'filled' : 'outlined'}
            key={variant}
            onClick={() => toggleVariant(variant)}
            label={variant ? toHumanReadable(variant).replace(' Plus', '+') : 'None'}
          />
        ))}
      </Stack>
    </>
  );
};
